import { render, staticRenderFns } from "./BoardMemberRemovedNotification.vue?vue&type=template&id=6ac4607d"
import script from "./BoardMemberRemovedNotification.vue?vue&type=script&lang=js"
export * from "./BoardMemberRemovedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports